var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOculusnew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.018,
    height: 15.487,
    viewBox: "0 0 25.018 15.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4a3a3",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2949",
    "data-name": "Group 2949",
    transform: "translate(-89.282 -405.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "oculus1",
    d: "M901.748,468.014c2.835-.018,5.662,0,8.506,0a9.971,9.971,0,0,1,2.842.314,7.181,7.181,0,0,1,.548,13.658,9.175,9.175,0,0,1-3.287.5h-8.244a8.5,8.5,0,0,1-3.5-.676,7.172,7.172,0,0,1-1.571-12.164,7.307,7.307,0,0,1,3.162-1.461,10.633,10.633,0,0,1,1.541-.164Zm-1.54,5.287a2.349,2.349,0,0,0-.7,3.143,2.508,2.508,0,0,0,1.94,1.189h9.833a2.588,2.588,0,0,0,1.51-.7,2.275,2.275,0,0,0,.672-1.3,2.338,2.338,0,0,0-.753-2.148,2.816,2.816,0,0,0-1.918-.659h-8.843a2.948,2.948,0,0,0-1.744.469Z",
    transform: "translate(-804.55 -62.462)",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOculusnew);
export default __webpack_public_path__ + "static/media/oculusnew.767087fd09ff8392181f86453d083c6f.svg";
export { ForwardRef as ReactComponent };